"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _InlineWysiwyg = _interopRequireDefault(require("../InlineWysiwyg"));
var _DragAndDrop = require("../DragAndDrop");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ObjectivesList = function ObjectivesList(_ref) {
  var formProps = _ref.formProps,
    section = _ref.section,
    sectionIndex = _ref.sectionIndex,
    setLearningObjectiveSections = _ref.setLearningObjectiveSections;
  var setObjectives = function setObjectives(objectives) {
    // Need to deep copy to force formProps.dirty and a re-render
    var updatedSection = _objectSpread(_objectSpread({}, section), {}, {
      objectives: objectives
    });
    var updatedLearningObjectives = _toConsumableArray(formProps.values.courseDescription.learningObjectives.sections);
    updatedLearningObjectives[sectionIndex] = updatedSection;
    setLearningObjectiveSections(updatedLearningObjectives);
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var sortedValues = (0, _DragAndDrop.dndSwap)(section.objectives.map(function (obj) {
      return _objectSpread({}, obj);
    }),
    // Deep copy
    fromIndex, toIndex);
    setObjectives(sortedValues);
  };
  var onClickAdd = function onClickAdd() {
    var objectives = _toConsumableArray(section.objectives);
    var highestKey = 0;
    objectives.forEach(function (obj) {
      if (obj.key > highestKey) {
        highestKey = obj.key;
      }
    });
    objectives.push({
      text: '',
      key: highestKey + 1
    });
    setObjectives(objectives);
  };
  var onClickDelete = function onClickDelete(key) {
    var objectives = _toConsumableArray(section.objectives).filter(function (objective) {
      return objective.key !== key;
    });
    setObjectives(objectives);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "objectives-".concat(section.key)
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef
    }), dropProvided.placeholder, section.objectives.map(function (objective, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "learning-objective-".concat(objective.key),
        index: index,
        key: "learning-objective-".concat(objective.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_style["default"].dragAndDropContent, " ").concat(_style["default"].removeMargin)
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.learningObjectives.sections[".concat(sectionIndex, "].objectives[").concat(index, "].text")
        })), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(objective.key);
          }
        }));
      });
    }), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
      onClick: onClickAdd
    }));
  }));
};
var _default = ObjectivesList;
exports["default"] = _default;